import { useContext } from 'react';

import { AdmindashboardContext } from '../context/AdmindashboardContext/AdmindashboardContext';

const useAdminDashboard = () => useContext(AdmindashboardContext);

export default useAdminDashboard;
